module.exports = __webpack_public_path__ + "static/media/fl_small_logo.a2f99e4b.png";